import React from 'react';
import styled from 'styled-components';
import CheckSvg from 'shared/statics/svg/Check-Blue.svg';

const CheckedIcon = styled.img.attrs({
  src: CheckSvg,
})`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 8px;
  border: 1px solid #CBD6E2;
`;

const UncheckedIcon = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid #CBD6E2;
`;

const Checkmark = ({ checked, id }) => checked
  ? <CheckedIcon {...{ id }} />
  : <UncheckedIcon {...{ id }} />;


export default Checkmark;
